/**
 * Shorten a string with ellipsis in the middle.
 * @param string - Input string (e.g. tx hash or address)
 * @param charNumberOrStart - If only this is passed: total chars to keep (start = this-4, end = 4). If startLength is also passed: number of chars at start.
 * @param endLength - Optional. If passed, first param is startLength: show startLength + '...' + endLength.
 */
export default function shortenString(
  string: string | null,
  charNumberOrStart: number | undefined = 8,
  endLength?: number,
) {
  if (!string) {
    return '';
  }

  if (endLength !== undefined) {
    const startLength = charNumberOrStart ?? 8;
    if (string.length <= startLength + endLength) return string;
    return string.slice(0, startLength) + '...' + string.slice(-endLength);
  }

  const charNumber = charNumberOrStart ?? 8;
  if (string.length <= charNumber) {
    return string;
  }

  return string.slice(0, charNumber - 4) + '...' + string.slice(-4);
}
